var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnviar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9878 19.5122L31 1.5M12.9878 19.5122L18.7189 30.9746C18.7908 31.1314 18.9061 31.2642 19.0512 31.3573C19.1964 31.4505 19.3652 31.5 19.5377 31.5C19.7101 31.5 19.8789 31.4505 20.0241 31.3573C20.1692 31.2642 20.2846 31.1314 20.3564 30.9746L31 1.5M12.9878 19.5122L1.52542 13.7811C1.36864 13.7092 1.23579 13.5939 1.14265 13.4488C1.04951 13.3036 1 13.1348 1 12.9623C1 12.7899 1.04951 12.6211 1.14265 12.4759C1.23579 12.3308 1.36864 12.2154 1.52542 12.1436L31 1.5",
    stroke: "#FF516C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnviar);
export default __webpack_public_path__ + "static/media/enviar.0f808773086bbf1dc3f80bb5c26fad09.svg";
export { ForwardRef as ReactComponent };